module.exports = __webpack_public_path__ + "img/[敲打].36251954.svg";